import * as Yup from 'yup';

export default Yup.object().shape({
  targetType: Yup.object().required('The target type for this target group is required.'),
});
